module.exports = __webpack_public_path__ + "media/vendors/vendors-md-ff368a61.png";